module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docs-sidebar-container"
  }, [_c('sidebar-view', {
    ref: "sidebar",
    attrs: {
      "item-key-field": "name",
      "list": _vm.itemsList,
      "common-actions": _vm.commonActions,
      "item-actions": _vm.itemActions
    },
    on: {
      "common-action": _vm.onCommonAction,
      "item-action": _vm.onItemAction
    }
  }), _vm._v(" "), _c('doc-name-dialog', {
    ref: "dialog",
    on: {
      "confirm": _vm.performDocCreate
    },
    model: {
      value: (_vm.currentDocName),
      callback: function($$v) {
        _vm.currentDocName = $$v
      },
      expression: "currentDocName"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-944ae3bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocsSidebarContainer.vue
// module id = 1018
// module chunks = 1